export default class AuthService {
  isInitialized() {
    return true;
  }

  whenInitialized() {
    return Promise.resolve(null);
  }

  isAuthenticated() {
    return true;
  }

  acceptRoute(/* route */) {
    return true;
  }

  getUsername() {
    return '';
  }

  getProfile() {
    return {};
  }

  getEmail() {
    return '';
  }

  getLastUsername() {
    return '';
  }

  authenticate(username/* , password */) {
    return Promise.resolve({ username });
  }

  changePassword(/* oldPassword, newPassword */) {
    return Promise.resolve(true);
  }

  logout() {
    return Promise.resolve({});
  }

  subscribe(/* onChange */) {}

  unsubscribe(/* onChange */) {}

  //
  // Tour
  //
  isSkipTour() { return true; }

  setSkipTour() {}
}
